<template>
	<div class="content-page">
		<Spinner :processor="{ loading: loading }" />
		<ActionSetNav
			:name="integratorName"
			:display="!loading"
			:actions="mainNavActions"
		/>
		<div class="content-page__heading">
			<div class="content-page__breadcrumb-title">
				<Breadcrumbs :items="urlNames" />
				<h2 class="content-page__title">
					3P Vendor Integration Manager
					<span class="content-page__title--detail"
						>- {{ title }}</span
					>
				</h2>
			</div>
		</div>
		<Stepper
			:steps="steps"
			:canDisabledNextStep="canEnableNextStep"
			:canEnableSubmit="canSubmit"
			:hasError="hasError"
			@cancel="handleCancel"
			@submit="save"
			@next="clicNextStep"
			@currentIndexActive="e => (currentIndexActive = e)"
		>
			<template #step-content0>
				<IntegrationGeneral
					v-model="integration"
					@valid="e => validateIntegrationGeneral(e)"
				></IntegrationGeneral>
			</template>
			<template #step-content1>
				<IntegrationSecureVue
					v-model="integration"
					@valid="e => (IsValidIntegrationToSend = e)"
				></IntegrationSecureVue>
			</template>
			<template #step-content2>
				<IntegrationDetails
					v-model="integration"
					@valid="e => (IsValidIntegrationToSend = e)"
				></IntegrationDetails>
			</template>
		</Stepper>
		<Modals
			title="The Integration Name and/or Alias entered matches existing records"
			:display="displayDuplicatesModal"
			data-test="modalIntegrationDuplicates"
			:includeCannotUndo="false"
			:buttons="matchesListButtons"
		>
			<template #modal-content>
				<div class="duplicates-vendor-modal">
					<div class="duplicates-vendor-modal__content-title">
						Do you want to view one of these?
					</div>

					<List
						:listItems="possiblesMatches"
						data-test="listPosiblesDuplicates"
						class="duplicates-vendor-modal__list"
					>
						<template #default="slotProps">
							<div
								class="duplicates-vendor-modal__card-item"
								:for="'possiblesDuplicates' + slotProps.item.id"
							>
								<div
									class="duplicates-vendor-modal__card-item-container"
								>
									<div
										class="duplicates-vendor-modal__card-item-integrationname"
									>
										{{ slotProps.item.integrationName }}
									</div>
									<div
										class="duplicates-vendor-modal__card-item-alias"
									>
										{{ slotProps.item.alias }}
									</div>
								</div>
								<div
									class="duplicates-vendor-modal__card-item-detail"
								>
									<Button
										className="btn--inline-link"
										labelText="View Details"
									/>
								</div>
							</div>
						</template>
					</List>

					<div class="duplicates-vendor-modal__clickback-text">
						Click Back to change the Integration Name
					</div>
				</div>
			</template>
			<template #modal-footer>
				<Button
					className="btn--primary"
					labelText="Back"
					:btnClick="closeModal"
					ref="backBtn"
				/>
			</template>
		</Modals>
	</div>
</template>

<script>
import ActionSetNav from '@/site-components/actions-set/action-set-nav';
import Stepper from '@/components/shells/stepper/stepper';
import Breadcrumbs from '@/components/shells/breadcrumbs/breadcrumbs';
import Spinner from '@/components/visual/spinner/spinner';
import IntegrationGeneral from './integration-general';
import IntegrationSecureVue from './integration-securevue';
import IntegrationDetails from './integration-details';
import Modals from '@/components/shells/modal/modals';
import List from '@/components/shells/list/list';
import _ from 'lodash';
import db from '../../../../../../db.json';
import Button from '@/components/forms/button/button';

export default {
	name: 'IntegrationAddSecureVUEIntegration',
	components: {
		Stepper,
		Breadcrumbs,
		Spinner,
		IntegrationGeneral,
		IntegrationSecureVue,
		IntegrationDetails,
		ActionSetNav,
		Modals,
		List,
		Button
	},
	props: {
		integratorId: {
			type: Number,
			default: null
		},
		integratorName: {
			type: String,
			default: 'Cox Automotive' //Dev. Delete this
		}
	},
	data() {
		return {
			currentIndexActive: 0,
			title: 'Add SecureVUE Integration',
			loading: false,
			steps: [
				{
					title: 'General',
					subtitle: ''
				},
				{
					title: 'SecureVue',
					subtitle: ''
				},
				{
					title: 'Integration Details',
					subtitle: ''
				}
			],
			mainNavActions: [
				{
					id: 1,
					action: {
						name: 'details'
					},
					title: 'Select to go to Details page',
					iconClass: 'icon icon-document',
					label: 'Details',
					type: 'route-link',
					visible: true
				},
				{
					id: 2,
					action: {
						name: 'ccl'
					},
					title: 'Select to go to Company customer location',
					iconClass: 'icon icon-company',
					label: 'CCL',
					type: 'route-link',
					visible: true
				},
				{
					id: 3,
					action: {
						name: 'parts'
					},
					iconClass: 'icon icon-customer-integration',
					label: 'APIs',
					title: 'Select to go to APIs',
					type: 'route-link',
					visible: true
				}
			],
			integration: db['integrator-integration'],
			canEnableNextStep: true,
			canSubmit: false,
			hasError: false,
			isIntegrationGeneralValid: false,
			IsValidIntegrationToSend: false,

			isIntegrationNameDuplicated: false,
			displayDuplicatesModal: false,
			matchesListButtons: [
				{
					className: 'btn--primary',
					labelText: 'Back',
					btnClick: this.goBack
				}
			],
			possiblesMatches: [
				{
					id: 1,
					integrationName: 'Xtime'
				},
				{
					id: 2,
					integrationName: 'TimeX',
					alias: 'Scheduler'
				}
			]
		};
	},
	computed: {
		urlNames() {
			let breadcrumbs = _.get(
				this,
				'$route.meta.breadcrumb',
				this.$store.getters.breadcrumbs(this.$route.path)
			);
			if (
				breadcrumbs.length > 0 &&
				breadcrumbs[breadcrumbs.length - 1].name !==
					'3P Vendor Integration Manager'
			) {
				breadcrumbs.push({ name: '3P Vendor Integration Manager' });
			}
			return breadcrumbs;
		}
	},
	methods: {
		validateIntegrationGeneral(value) {
			this.isIntegrationGeneralValid = value;

			this.CheckIntegrationNameDuplicated();
			this.hasError = this.isIntegrationNameDuplicated;
			this.IsValidIntegrationToSend = value;
		},
		handleCancel() {
			//integrators/{id}/integrations route
			this.integration = {};
			this.$router.push({
				path: `/vendors/${this.integratorId}/integrations`
			});
		},
		close() {
			this.handleCancel();
		},
		save() {
			let showErrors = false; //Dev remove showErrors after implementation
			//UIUX  to display error toast  message uncomment below lines
			// showErrors = true;

			const self = this;
			const displayMessage = statusCode => {
				self.$store.dispatch('toastMessages/show', {
					toastId: 'integration.addsecurevue',
					statusCode: statusCode,
					message:
						statusCode == 200
							? 'Integration successfully added'
							: 'An error occured saving the integration. Please try saving again.',
					slot: 'default',
					useIcon: true,
					userDismissable: true
				});
			};
			//call api to save integrations
			this.loading = true;

			//Dev remove setTimeout after implementation
			setTimeout(() => {
				displayMessage(showErrors ? 400 : 200);
				this.loading = false;
				if (!showErrors) {
					this.close();
				}
			}, 3000);
		},
		CheckIntegrationNameDuplicated() {
			//call api search integration name and alias duplicated -- after than remove this code
			this.isIntegrationNameDuplicated = this.possiblesMatches.some(x =>
				x.integrationName
					.toLowerCase()
					.includes(this.integration.name.toLowerCase())
			);
		},
		clicNextStep() {
			if (
				this.isIntegrationGeneralValid &&
				this.currentIndexActive == 0
			) {
				//call api search integration name and alias duplicated -- after than remove this code
				this.CheckIntegrationNameDuplicated();
				this.displayDuplicatesModal = this.isIntegrationNameDuplicated;
				this.hasError = this.isIntegrationNameDuplicated;
			} else {
				this.hasError = false;
			}

			this.IsValidIntegrationToSend = !this.hasError;
		},
		goBack() {
			this.integration.name = '';
			this.integration.alias = '';
			this.isIntegrationNameDuplicated = false;
			this.displayDuplicatesModal = false;
		},
		loadIntegrationDetailPage(integrationId) {
			this.integration = {};
			this.$router.push({
				path: `/vendors/${this.integratorId}/integrations/${integrationId}`
			});
		}
	},
	watch: {
		IsValidIntegrationToSend: {
			immediate: true,
			handler(val) {
				this.canEnableNextStep = !val;
				this.canSubmit = val;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
::v-deep .modal {
	@include mq($from: md) {
		width: 400px;
	}
}
.duplicates-vendor-modal {
	display: flex;
	flex-direction: column;
	gap: $gutter-lg;
	@include body-text('regular');

	&__list {
		display: flex;
		flex-direction: column;
		gap: $gutter-lg;
		max-height: 200px;
		@include scrollbar;
		overflow-y: auto;
	}

	&__card-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: $padding-md;
		background-color: $neutral-4;
	}

	&__card-item-integrationname {
		@include body-text('regular-emphasis');
	}

	&__card-item-alias {
		@include body-text('regular');
		margin-top: $gutter-sm;
	}

	&__clickback-text {
		margin-bottom: $gutter-lg;
	}
}
</style>
